





















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop , Watch } from "vue-property-decorator";
import axios, { AxiosResponse } from "axios";
import { Token } from "../utils/Token";
import { EventBus } from "../event-bus";
import { File } from "../models/File";
import { VForm, VCard, VCardTitle, VFileInput, VBtn, VTextField, VSpacer } from "vuetify/lib";
import { isFolderAccessSupported, getSavedFolder, chooseFolder, pickFiles } from "../utils/folderAccess";


@Component({
  components: {},
})
export default class FileExplorer extends Vue {
  @Prop() selected!: any;
  private fileRule: any = [];
  private previousName="";
  private renameLabel="";
  private nameFile={
    name: "",
    ext: "",
  };

  private files:Array<File>=[];
  private fileToUpload:any=null;

  private folderAccess = isFolderAccessSupported();
  private saderName = "";
  
  private isUploadEnabled = true;
  private isRenameEnabled = true;
  private isRenameTextEnabled= true;
  private isDeleteEnabled = true;
  private isDownloadEnabled = true;
  private isPrintEnabled = true;

  private changesMade = false;
  private flag=true;
  
  created(){

    EventBus.$on("selectedChanded", (value: File[]) => {
      if (value!==undefined){
      this.files = value;
      }else{
       console.log("diselected");
       this.files=[];
      }
      console.log("selectedChanded FE "+this.files);
    });


    this.checkEnabled();
    this.loadSaderName();
    this.fileRule = [
      (v: any) => !!v || "Name is required",
      (v: any) =>
        /^[a-zA-Z0-9][a-zA-Z0-9\-_]*(.[a-zA-Z0-9]+)?$/.test(v) || "not valid name",
      (v: any) =>
        /^.{1,50}$/.test(v) || "First Name max length is 50 characters",
    ];
    
  }

  @Watch("files")
  private checkEnabled(){
    this.isDeleteEnabled=true;
    this.isDownloadEnabled=true;
    this.isRenameEnabled=true;
    this.isPrintEnabled = true;
    this.changesMade = false;

    this.renameLabel="Name";
    this.previousName="";
    this.isRenameTextEnabled=true;
    this.nameFile={
    name: "",
    ext: "",
    };
    //&& this.file.name!=""
    if (this.files!==undefined && this.files.length>0 ){
      this.isDeleteEnabled=false;
      this.isDownloadEnabled=false;

        if (this.files.some(e => e.name.includes("pdf")) ||
            this.files.some(e => e.name.includes("doc")) ||
            this.files.some(e => e.name.includes("docx")) ||
            this.files.some(e => e.name.includes("tiff")) ||
            this.files.some(e => e.name.includes("jpg")) ||
            this.files.some(e => e.name.includes("png"))) {
            this.isPrintEnabled = false;
        }

      if (this.files.length==1 && this.files[0].type != 3) {
        this.isRenameTextEnabled=false;
        this.isRenameEnabled=false;
        this.renameLabel=this.files[0].name;
        this.previousName=this.files[0].name;
      }
    }
    //console.log("up rename del down",this.isUploadEnabled, this.isRenameEnabled,this.isDeleteEnabled,this.isDownloadEnabled)
  }

  @Watch("fileToUpload")
  private checkEnabledUpload(){
    console.log(this.fileToUpload);
    this.isUploadEnabled=(this.fileToUpload != null ? false : true);
    //if this.fileToUpload
  };

  get pickedNames(): string {
    if (!this.fileToUpload || this.fileToUpload.length === 0) {
      return "";
    }
    return this.fileToUpload.map((f: any) => f.name).join(", ");
  }

  private async loadSaderName() {
    const sader = await getSavedFolder("sader");
    this.saderName = sader ? sader.name : "";
  }

  private async ChooseSader() {
    const sader = await chooseFolder("sader", "read");
    if (sader) {
      this.saderName = sader.name;
    }
    return sader;
  }

  // "Open file": file picker starting in the remembered Sader folder
  private async OpenFromSader() {
    const sader = await getSavedFolder("sader");

    if (!sader) {
      // first use: choosing the folder uses up the click, the files are picked on the next one
      if (await this.ChooseSader()) {
        EventBus.$emit("showSnackbar", {
          text: `Sader folder set to "${this.saderName}". Click Open file to choose the files.`,
          color: "#4caf50",
        });
      }
      return;
    }

    try {
      const picked = await pickFiles(sader);
      if (picked.length > 0) {
        this.fileToUpload = picked;
      }
    } catch (err) {
      console.log("error:", err);
      EventBus.$emit("showSnackbar", {
        text: "Error: Unable to open the file picker.",
        color: "#2196f3",
      });
    }
  }

  // dropping files on "Open file" works as it did with the file input
  private DropFiles(event: DragEvent) {
    const dropped = event.dataTransfer ? Array.from(event.dataTransfer.files) : [];
    if (dropped.length > 0) {
      this.fileToUpload = dropped;
    }
  }

  private renameText(inputText:string):any{
    const nFile={
    name: "",
    ext: "",
    };

    const temp=inputText.split(".");
    nFile.name=temp[0];
    if (temp.length>1){
      nFile.ext=temp[1];
    }

    return nFile; 
  }

private async UploadFunction(){
    const token = await Token.getTokenWithExpiry("token");
    
    const formData = new FormData();
    for(let i = 0; i < this.fileToUpload.length; i++ ){
        const file = this.fileToUpload[i];
        formData.append('files', file);
    }

    axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/file`,
      data:formData,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        this.flag=false;
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
              const files=response.data.files;
              //add new file to table;
              EventBus.$emit("newFileAddition", files);
              //EventBus.$emit("changeMade");
              EventBus.$emit("unselected")
              this.flag=true;
            }

          const snackbarData = {
          text:
            this.flag === true
              ? "File Uploaded."
              : "Error: File not uploaded.",
          color: this.flag === true ? "#4caf50" : "#2196f3",
          };
          EventBus.$emit("showSnackbar", snackbarData);
          }       
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
      
    }


//PUT("/api/file/:id)
  private async RenameFunction(){
    const token = await Token.getTokenWithExpiry("token");
    const data={
      name:this.previousName,
      file:this.files[0],
    };
    //EventBus.$emit("BeginLoader",null );   

    //path remains the same so as to find the file to rename
    axios({
      method: "put",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/file`,
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          this.flag=false;
          if (response.data.code == 200) {
            const newFile = response.data.file;
            //remove old file from table 
            EventBus.$emit("fileRemoval", [data.file]);
            //add new file to table
            EventBus.$emit("newFileAddition", [newFile]);
            EventBus.$emit("changeMade")
            this.flag=true;
          }
          const snackbarData = {
          text:
            this.flag === true
              ? "File Renamed."
              : "Error: File not renamed.",
          color: this.flag === true ? "#4caf50" : "#2196f3",
          };
          EventBus.$emit("showSnackbar", snackbarData);

        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
    }

  private getId(file:File):string{
    //possible paths:
    ///root/src/files/{name}
    ///home/sct-client-x/files/received/{name}
    //if before files is root source send -1 else split(-) to get id of user

    let id="-1";
    const temp=file.path.split("/files");
    if (temp[0]!="/root/src"){
      const temp2=temp[0].split("-");
      id=temp2[temp2.length - 1];
      console.log(id);
    }
    return id;    
  }

  //delete api/file
  private async DeleteFunction(){
    const token = await Token.getTokenWithExpiry("token");
    const files:Array<any>=[];
    this.files.forEach(e=>files.push({id:"-1", name: e.name}));
    //EventBus.$emit("BeginLoader",null );   

    axios({
      method: "delete",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/file`,
      data:{files:files},
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          this.flag=false;
          if (response.data.code == 200) {
            //remove old file from table 
            EventBus.$emit("fileRemoval", this.files);
            EventBus.$emit("changeMade")
            this.previousName="";
            this.renameLabel="";
            this.flag=true;
          }
          const snackbarData = {
          text:
            this.flag === true
              ? "File Deleted."
              : "Error: File not deleted.",
          color: this.flag === true ? "#4caf50" : "#2196f3",
          };
          EventBus.$emit("showSnackbar", snackbarData);
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
    }
  
    // get /files/download
  private async DownloadFunction(){
    const token = await Token.getTokenWithExpiry("token");
    const files:Array<any>=[];
    this.files.forEach(e=>files.push({id:this.getId(e) ,name: e.name}));
    //EventBus.$emit("BeginLoader",null );   
    const axiosList:any=[];
    files.forEach((e)=>  
      axiosList.push(
        axios.get(`${process.env.VUE_APP_BASE_URL}/files/download/-1/${e.name}`, {
        withCredentials: true,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-type": "application/json",
        }
    }) )
    );

    axios.all(axiosList)
    .then(axios.spread((...responses) => {
      for(let i = 0; i < responses.length; i++) {
        const response=responses[i] as AxiosResponse;
        console.log("resp: ",response);

        const data=response.data as Blob;
        const FILE = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = FILE;
        let disposition=response.config.url;
        disposition===undefined?  disposition="/file": ""
        const temp=disposition.split('/');
        link.download =temp[temp.length-1];
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        console.log("resp: ",data);
      }
        EventBus.$emit("unselected")
        EventBus.$emit("ReloadLogs", null);    }))
      .catch(errors => {
        console.log(errors);
      })
    }

    private async PrintFunction() {
        console.log("Trying to print.");
        const token = await Token.getTokenWithExpiry("token");
        const files: Array<any> = [];
        this.files.forEach(e => files.push({id: this.getId(e), name: e.name}));
        //EventBus.$emit("BeginLoader",null );
        const axiosList: any = [];

        files.forEach((e) =>
            axiosList.push(
                axios.get(`${process.env.VUE_APP_BASE_URL}/files/download/-1/${e.name}`, {
                    withCredentials: true,
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-type": "application/json",
                    }
                })
            )
        );

        axios.all(axiosList)
        .then(axios.spread((...responses) => {
            for(let i = 0; i < responses.length; i++) {
                const response = responses[i] as AxiosResponse;
                console.log("resp: ", response);
                const blobURL = URL.createObjectURL(response.data);

                const iframe = document.createElement("iframe");
                document.body.appendChild(iframe);

                iframe.style.display = "none";
                iframe.src = blobURL;
                iframe.onload = function() {
                    setTimeout(function() {
                        iframe.focus();
                        iframe.contentWindow?.print();
                    }, 1);
                }
            }
            EventBus.$emit("unselected");
            EventBus.$emit("ReloadLogs", null);
        }))
        .catch(errors => {
            console.log(errors);
        })
    }
}
